import request from '@/utils/request';

export function getPlanRecommendList(params, silentRequest = false) {
  return request({
    url: '/Schedule/surveyResult',
    params,
    silentRequest,
  });
}

export function getLearningSurveyResult(params) {
  return request({
    url: '/Learning/surveyResult',
    params,
  });
}

export function getLearningChooseTagStatus(silentRequest = false) {
  return request({
    url: '/Learning/chooseTagStatus',
    silentRequest,
  });
}

export function getLearningSurveyInfo() {
  return request({
    url: '/Learning/surveyInfo',
  });
}

export function getLearningInfo() {
  return request({
    url: '/Learning/index',
  });
}
